module.exports = __webpack_public_path__ + "img/reorder.6fedf48c.svg";